import { render, staticRenderFns } from "./FormImageWithLabel.vue?vue&type=template&id=810998dc&"
import script from "./FormImageWithLabel.vue?vue&type=script&lang=js&"
export * from "./FormImageWithLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports